import axios from '../api/axiosInstance';

export const fetchCustomers = (params) => {
  return axios.get('/customers', { params });
};

export const createCustomer = (data) => {
  return axios.post('/customers', data);
};

export const updateCustomer = (id, data) => {
  return axios.put(`/customers/${id}`, data);
};

export const updateCustomerStatus = (id, status) => {
  return axios.patch(`/customers/${id}/status`, { status });
};

export const deleteCustomer = (id) => {
  return axios.delete(`/customers/${id}`);
};
